export default {
    path: 'awards',
    name: 'AwardForm',
    component() {
        return import('@/components/award/AwardForm.vue')
    },
    children: [
        {
            path: '',
            name: 'AwardList',
            component() {
                return import('@/components/award/award/AwardList.vue')
            },
        },
        {
            path: ':awrdNo',
            name: 'AwardDetail',
            component() {
                return import('@/components/award/award/AwardDetail.vue')
            },
        },
    ],
}